import { Route, Router, Switch } from 'react-router';

import DataAndConsentsContent from './DataAndConsentsContent/DataAndConsentsContent';

const DataAndConsents = ({ history, match }) => (
  <Router history={history}>
    <Switch>
      <Route path={`${match.url}/`} component={DataAndConsentsContent} />
    </Switch>
  </Router>
);

export default DataAndConsents;
